import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  ACTIVITY_ADMINISTRATIVE_INCIDENT,
  CLEAR_ADMINISTRATIVE_INCIDENTS,
  FLAG_GETTING_ADMINISTRATIVE_INCIDENTS,
  GET_ADMINISTRATIVE_INCIDENTS,
} from '../../../actions/types/supervision-control';

const INITIAL_STATE = Immutable.Map({
  administrativeIncidents: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  administrativeIncidentActivity: Immutable.Map({
    loading: false,
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_ADMINISTRATIVE_INCIDENTS:
      return state.setIn(
        ['administrativeIncidents', 'loading'],
        action.payload,
      );
    case GET_ADMINISTRATIVE_INCIDENTS:
      return state.setIn(
        ['administrativeIncidents', 'content'],
        Immutable.Map(action.payload),
      );
    case CLEAR_ADMINISTRATIVE_INCIDENTS:
      return state.setIn(
        ['administrativeIncidents', 'content'],
        Immutable.Map(COLLECTION_SHAPE),
      );
    case ACTIVITY_ADMINISTRATIVE_INCIDENT:
      return state.setIn(
        ['administrativeIncidentActivity', 'loading'],
        action.payload,
      );
    default:
      return state;
  }
};
